import { createStore, withProps } from '@ngneat/elf';

export interface SeuilsGlobalStateProps {
  response: any;
  dto: {
    typeMarcherId: number | null;
    montant: number | null;
  };
  serverState: any;
}

export const seuilsGlobalInitialState: SeuilsGlobalStateProps = {
  response: null,
  dto: {
    typeMarcherId: null,
    montant: null,
  },
  serverState: undefined,
};

export const seuilsGlobalStateStore = createStore(
  { name: 'seuils-global-state' },
  withProps<SeuilsGlobalStateProps>({
    ...seuilsGlobalInitialState,
  })
);
